import { render, staticRenderFns } from "./htCnDeatilsTabs.vue?vue&type=template&id=b631a800&scoped=true&"
import script from "./htCnDeatilsTabs.vue?vue&type=script&lang=js&"
export * from "./htCnDeatilsTabs.vue?vue&type=script&lang=js&"
import style0 from "./htCnDeatilsTabs.vue?vue&type=style&index=0&id=b631a800&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b631a800",
  null
  
)

export default component.exports